import React, { useState, useMemo, useEffect } from 'react';

import { Paper } from '@material-ui/core';
import PropTypes from 'prop-types';

import { MultiAutocomplete } from '~/components/Form';
import { Select } from '~/components/Form/v2';
import { t } from '~/helpers';

import * as S from './styles';

function Header({ onSubmit, icon, disabled }) {
  const [posto, setPosto] = useState(null);
  const [produto, setProduto] = useState(null);
  const [periodo, setPeriodo] = useState(30);

  const optionsPeriodo = useMemo(() => {
    const strDias = t('s.geral.dias').toLowerCase();

    return [
      { value: 30, label: `30 ${strDias}` },
      { value: 15, label: `15 ${strDias}` },
      { value: 7, label: `7 ${strDias}` },
    ];
  }, []);

  useEffect(() => {
    const params = {
      periododias: periodo,
    };

    if (posto) {
      params.idposto = posto.idposto;
      params.codigonomeposto = posto.codigonomeposto;
    }

    if (produto) {
      params.idproduto = produto.idproduto;
      params.nomeproduto = produto.nomeproduto;
    }

    console.log(params);

    onSubmit(params);
  }, [posto, produto, periodo]);

  return (
    <S.WrapperForm component={Paper}>
      <Select
        name="periodo"
        label={t('s.geral.periodo')}
        data={optionsPeriodo}
        defaultValue={30}
        getValue={(value) => {
          console.log(value.value);
          setPeriodo(value.value);
        }}
        disabled={disabled}
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        getValue={(value) =>
          setPosto((prevState) => ({
            ...prevState,
            idposto: value.map((posto) => posto.idposto),
          }))
        }
      />

      <MultiAutocomplete
        multiple
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        getValue={(value) =>
          setProduto((prevState) => ({
            ...prevState,
            idproduto: value.map((posto) => posto.idproduto),
          }))
        }
        params={{
          wherefield: 'tipoproduto',
          valuewherefield: 'C',
          typewherefield: 'EQUALS',
        }}
      />

      <div style={{ width: '200%' }} />

      {icon && <S.IconWrapper>{icon}</S.IconWrapper>}
    </S.WrapperForm>
  );
}

Header.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  icon: PropTypes.element,
  disabled: PropTypes.bool,
};

Header.defaultProps = {
  icon: null,
  disabled: false,
};

export default Header;
